var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 143 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.888.017C85.5 0 85.086 0 84.698 0H0v26.317h135.47C126.861 9.052 110.341.284 85.888.017zM95.36 47.266H0v26.3h69.059c14.527 0 26.302-11.776 26.302-26.3zM141.585 47.265H134.9c-14.527 0-26.302 11.775-26.302 26.3h33.45c.318-3.628.479-7.45.479-11.45 0-5.283-.322-10.245-.942-14.85zM31.527 94.514H0v26.299h5.229c14.523 0 26.298-11.774 26.298-26.3zM44.75 120.813h64.418a24.58 24.58 0 0018.213-8.069l.087-.093c4.461-4.872 7.946-10.9 10.419-18.137h-66.84c-14.522 0-26.297 11.775-26.297 26.299zM0 168.043h27.493c14.522 0 26.297-11.774 26.297-26.299H0v26.299z",
    fill: "#fff"
  })));
}

export default __webpack_public_path__ + "b5ad24500200a143814103d6c027e75e.svg";
export { SvgLogoLight as ReactComponent };